angular.module('swapick')
.controller('BuyCtrl', BuyCtrl);

function BuyCtrl($scope, $http, DataService, $stateParams,
  Categories, $ionicModal, initialLoaderManager, $q, $ionicPopup,
  $ionicScrollDelegate, SwapService, Entities, $ionicLoading,
  $state, $ionicHistory, notifyManager) {


  this.you = null;
  this.me = null;

  this.myMoney = parseInt($stateParams.myMoney || 0);

  this.yourObjectId = $stateParams.yourObjectId;
  this.yourImages = [];

  this.requestSent = false;

  //loading function
  this.processObj = (obj) => {

    this.yourObject = obj;
    this.you = obj.posseduto_da[0];
    this.yourImages = [obj.immagine].concat(_.map(obj.altre_immagini, 'percorso'));

    return Entities.waitForUser()
    .then((u)=>{
      this.me = u;
      return u;
    })
  }

  this.loader = initialLoaderManager.makeLoader(()=>{

    if($stateParams.objFromList && $stateParams.objFromList.id == $stateParams.yourObjectId){
      return this.processObj($stateParams.objFromList);
    }

    return DataService.items.one(this.yourObjectId)
    .get()
    .then(obj => {
      return this.processObj(obj);
    })
  }, false);

  $scope.$on('$ionicView.beforeEnter', () => {
      if(!this.yourObject){
        this.loader.load();
      }
  });



  this.confirmProposal = () => {
    var confirmPopup = $ionicPopup.confirm({
     title: 'Offerta di acquisto',
     cancelText: 'Annulla',
     scope : $scope,
     template: `<p>Confermi la proposta di acquisto?</p>
        <div class="item item-text-wrap">
        <p>
          Stai cercando di acquistare "{{BuyCtrl.yourObject.titolo}}" da <b>{{BuyCtrl.you.user.nome}}</b>
          per {{BuyCtrl.myMoney}} €.
        </p>
        </div>`
   });

   confirmPopup.then((res) => {
     if(res) {
       console.log('You are sure');
       this.confirmRequest();
     } else {
       console.log('You are not sure');
     }
   });
  }


  this.confirmRequest = () => {
    let data = {
      user_from : {
        id : this.me.id,
        ecoin : parseInt(this.myMoney)
      },
      user_to : {
        id : this.you.user.id,
        items : [ this.yourObjectId ]
      }

    };

    console.info("data", data)
    $ionicLoading.show();
    DataService
    .swaps
    .post(data)
    .then(resp => {
      console.log(resp)
      this.requestSent = true;
      notifyManager.success("Richiesta inviata");
      this.toRequestSent();
    })
    .finally(()=>{
      $ionicLoading.hide();
    })


  };


  this.toRequestSent = () => {
    if(!this.requestSent){
      return;
    }
    $ionicHistory.nextViewOptions({
      disableBack: true,
      historyRoot : true,
    });
    //$ionicHistory.clearCache()
    return $state.go("app.logged.swaps")
  }



  this.addMoney = () => {
    $scope.tempData = {};
    $scope.tempData.tempMoney = this.myMoney || 0;

    // An elaborate, custom popup
    var myPopup = $ionicPopup.show({
      template: `<input type="number" ng-model="tempData.tempMoney">`,
        title: 'Fai offerta',
        subTitle: 'Inserisci l\'importo in €',
        scope: $scope,
        buttons: [
          { text: 'Annulla', onTap : (e)=>{
            return this.myMoney;
            myPopup.close() }
          },
          {
            text: '<b>OK</b>',
            type: 'button-positive',
            onTap: (e) => {
              return $scope.tempData.tempMoney || 0;
              if (!SwapCtrl.tempMoney) {
                //don't allow the user to close unless he enters wifi password
                e.preventDefault();
              } else {

              }
            }
          }
        ]
  });

  myPopup.then((res) => {
    console.log('Tapped!', res);
    this.myMoney = res;

  });

  };




}



// WEBPACK FOOTER //
// ./src/controllers/buy-controller.js